import { OpenApiDocumentationSections } from "@/types/breeze/ApiDoc";
import { BaseService } from "../BaseService";

export class ApiDocsService extends BaseService {
  public async getDocs(): Promise<OpenApiDocumentationSections> {
    return this.getRequest("/docs");
  }
}

export const apiDocsService = new ApiDocsService();
